module.exports = __webpack_public_path__ + "media/images/check-new-4ad2fc3ec6763a73ac3539f802670456.svg";